import React from "react";
import TextInput from "./TextInput";
import TimeInput from "./TimeInput";
import TextNumberInput from "./TextNumberInput";
import SelectInput from "./SelectInput";
import FixButton from "./Button";
import InserimentoMultiploWidget from "./InserimentoMultiploWidget";
import Cookies from "universal-cookie";
import Utils from "../utils/utils";
import GetInsegnanti from "../services/getInsegnanti";
import GetMaterie from "../services/getMaterie";
import GetAule from "../services/getAule";
import AddLezione from "../services/addLezione";
import addSessioneLezione from "../services/addSessioneLezione";
import getCorsi from "../services/getCorsi";
import getChiusura from "../services/getChiusura";
import getCorso from "../services/getCorso";
import moment from "moment";
import Checkbox from "./CheckBox";
import { Button } from "@material-ui/core";
import "react-datepicker/dist/react-datepicker.css";
import MyDatePicker from "./NewDatePicker";

export default class InsertMeetingWidget extends React.Component {
  constructor(props) {
    super(props);

    this.selectRef = React.createRef();
    this.selectBrokerRef = React.createRef();
    this.selectBreakRef = React.createRef();
    this.inserimentoMultiploWidget = React.createRef();

    this.subjectsRepresentative = [];
    this.valueRepresentative = [];

    this.subjects = [];
    this.state = {
      visible: false,
      selected: "meeting",
      date: moment(new Date()).format("YYYY-MM-DD"),
      time: "08:00",
      isLoading: false,
      materia: null,
      selectedInsegnanti: [],
      selectedMaterie: [],
      pagamentoQuota: false,
      divisaInMeta: false, // NUOVO: flag per divisione giornata
      // Prima metà
      selectedInsegnantiMeta1: [],
      selectedMaterieMeta1: [],
      selectedAuleMeta1: [],
      oraInizioMeta1: "09:30",
      oraFineMeta1: "13:00",
      // Seconda metà
      selectedInsegnantiMeta2: [],
      selectedMaterieMeta2: [],
      selectedAuleMeta2: [],
      oraInizioMeta2: "14:00",
      oraFineMeta2: "18:00",
    };

    this._isMounted = false; // Flag per controllare se il componente è montato
  }
  async componentDidMount() {
    this._isMounted = true; // Impostiamo il flag quando il componente è montato
    this.count = 0;

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const eventId = cookies.get("currentEventId", { path: "/" });

    this.insegnanti = await GetInsegnanti(username, token);
    this.materie = await GetMaterie(username, token);
    this.aule = await GetAule(username, token);
    this.corsi = await getCorsi(username, token);

    this.selectInsegnanti = [];
    this.selectMaterie = [];
    this.selectAule = [];
    this.selectCorsi = [];

    this.insegnanti &&
      this.insegnanti.forEach((b) => {
        this.selectInsegnanti.push({
          value: b.id,
          label: b.nome + " " + b.cognome,
        });
      });

    this.aule &&
      this.aule.forEach((b) => {
        this.selectAule.push({ value: b.id, label: b.nome });
      });

    this.materie &&
      this.materie.forEach((b) => {
        this.selectMaterie.push({
          value: b.id,
          label: b.materia + (b.note ? " - " + b.note : ""),
        });
      });

    this.corsi &&
      this.corsi.forEach((b) => {
        this.selectCorsi.push({ value: b.id, label: b.name });
      });

    if (this.props.subjectId == undefined) return;
    let scheduleType = this.props.scheduleType;
    this.subjects = [];

    this.setState({
      visible: this.props.visible,
      scheduleType: scheduleType,
      slots: 1,
      //	materia: undefined,
      aula: undefined,
      valueRepresentative: this.valueRepresentative,
      brokers: this.brokerSelected,
    });
  }

  componentWillUnmount() {
    this._isMounted = false; // Impostiamo il flag a false quando il componente viene smontato
  }

  lockedSaveLesson = Utils.disallowConcurrency(this.saveLesson.bind(this));

  addInsegnante = () => {
    this.setState((prevState) => ({
      selectedInsegnanti: [...prevState.selectedInsegnanti, null],
    }));
  };

  removeInsegnante = (index) => {
    this.setState((prevState) => {
      const selectedInsegnanti = [...prevState.selectedInsegnanti];
      selectedInsegnanti.splice(index, 1);
      return { selectedInsegnanti };
    });
  };

  handleInsegnanteChange = (option, index) => {
    this.setState((prevState) => {
      const selectedInsegnanti = [...prevState.selectedInsegnanti];
      selectedInsegnanti[index] = option;
      return { selectedInsegnanti };
    });
  };

  addMateria = () => {
    this.setState((prevState) => ({
      selectedMaterie: [...prevState.selectedMaterie, null],
    }));
  };

  removeMateria = (index) => {
    this.setState((prevState) => {
      const selectedMaterie = [...prevState.selectedMaterie];
      selectedMaterie.splice(index, 1);
      return { selectedMaterie };
    });
  };

  handleMateriaChange = (option, index) => {
    this.setState((prevState) => {
      const selectedMaterie = [...prevState.selectedMaterie];
      selectedMaterie[index] = option;
      return { selectedMaterie };
    });
  };

  handleDateChange = (val) => {
    const formattedDate = moment(val).format("YYYY-MM-DD");
    this.setState({ date: formattedDate });
  };

  // NUOVO: Metodi per gestire insegnanti metà 1
  addInsegnanteMeta1 = () => {
    this.setState((prevState) => ({
      selectedInsegnantiMeta1: [...prevState.selectedInsegnantiMeta1, null],
    }));
  };

  removeInsegnanteMeta1 = (index) => {
    this.setState((prevState) => {
      const selectedInsegnantiMeta1 = [...prevState.selectedInsegnantiMeta1];
      selectedInsegnantiMeta1.splice(index, 1);
      return { selectedInsegnantiMeta1 };
    });
  };

  handleInsegnanteMeta1Change = (option, index) => {
    this.setState((prevState) => {
      const selectedInsegnantiMeta1 = [...prevState.selectedInsegnantiMeta1];
      selectedInsegnantiMeta1[index] = option;
      return { selectedInsegnantiMeta1 };
    });
  };

  // NUOVO: Metodi per gestire materie metà 1
  addMateriaMeta1 = () => {
    this.setState((prevState) => ({
      selectedMaterieMeta1: [...prevState.selectedMaterieMeta1, null],
    }));
  };

  removeMateriaMeta1 = (index) => {
    this.setState((prevState) => {
      const selectedMaterieMeta1 = [...prevState.selectedMaterieMeta1];
      selectedMaterieMeta1.splice(index, 1);
      return { selectedMaterieMeta1 };
    });
  };

  handleMateriaMeta1Change = (option, index) => {
    this.setState((prevState) => {
      const selectedMaterieMeta1 = [...prevState.selectedMaterieMeta1];
      selectedMaterieMeta1[index] = option;
      return { selectedMaterieMeta1 };
    });
  };

  // NUOVO: Metodi per gestire insegnanti metà 2
  addInsegnanteMeta2 = () => {
    this.setState((prevState) => ({
      selectedInsegnantiMeta2: [...prevState.selectedInsegnantiMeta2, null],
    }));
  };

  removeInsegnanteMeta2 = (index) => {
    this.setState((prevState) => {
      const selectedInsegnantiMeta2 = [...prevState.selectedInsegnantiMeta2];
      selectedInsegnantiMeta2.splice(index, 1);
      return { selectedInsegnantiMeta2 };
    });
  };

  handleInsegnanteMeta2Change = (option, index) => {
    this.setState((prevState) => {
      const selectedInsegnantiMeta2 = [...prevState.selectedInsegnantiMeta2];
      selectedInsegnantiMeta2[index] = option;
      return { selectedInsegnantiMeta2 };
    });
  };

  // NUOVO: Metodi per gestire materie metà 2
  addMateriaMeta2 = () => {
    this.setState((prevState) => ({
      selectedMaterieMeta2: [...prevState.selectedMaterieMeta2, null],
    }));
  };

  removeMateriaMeta2 = (index) => {
    this.setState((prevState) => {
      const selectedMaterieMeta2 = [...prevState.selectedMaterieMeta2];
      selectedMaterieMeta2.splice(index, 1);
      return { selectedMaterieMeta2 };
    });
  };

  handleMateriaMeta2Change = (option, index) => {
    this.setState((prevState) => {
      const selectedMaterieMeta2 = [...prevState.selectedMaterieMeta2];
      selectedMaterieMeta2[index] = option;
      return { selectedMaterieMeta2 };
    });
  };

  // NUOVO: Metodi per gestire aule metà 1
  addAulaMeta1 = () => {
    this.setState((prevState) => ({
      selectedAuleMeta1: [...prevState.selectedAuleMeta1, null],
    }));
  };

  removeAulaMeta1 = (index) => {
    this.setState((prevState) => {
      const selectedAuleMeta1 = [...prevState.selectedAuleMeta1];
      selectedAuleMeta1.splice(index, 1);
      return { selectedAuleMeta1 };
    });
  };

  handleAulaMeta1Change = (option, index) => {
    this.setState((prevState) => {
      const selectedAuleMeta1 = [...prevState.selectedAuleMeta1];
      selectedAuleMeta1[index] = option;
      return { selectedAuleMeta1 };
    });
  };

  // NUOVO: Metodi per gestire aule metà 2
  addAulaMeta2 = () => {
    this.setState((prevState) => ({
      selectedAuleMeta2: [...prevState.selectedAuleMeta2, null],
    }));
  };

  removeAulaMeta2 = (index) => {
    this.setState((prevState) => {
      const selectedAuleMeta2 = [...prevState.selectedAuleMeta2];
      selectedAuleMeta2.splice(index, 1);
      return { selectedAuleMeta2 };
    });
  };

  handleAulaMeta2Change = (option, index) => {
    this.setState((prevState) => {
      const selectedAuleMeta2 = [...prevState.selectedAuleMeta2];
      selectedAuleMeta2[index] = option;
      return { selectedAuleMeta2 };
    });
  };

  render() {
    let st = Object.assign(
      { minHeight: "600px", display: this.state.visible ? "block" : "none" },
      mainClass
    );

    const momentDate = moment(this.state.date, "YYYY-MM-DD", true);
    const selectedDate = momentDate.isValid() ? momentDate.toDate() : null;

    return (
      <div style={st}>
        <div
          style={closeIcon}
          onClick={() => {
            this.setState({ visible: false });
            this.props.onDone();
          }}
        >
          X
        </div>
        <div
          style={{
            marginTop: "10px",
            display: this.state.selected == "meeting" ? "block" : "none",
          }}
        >
          <div className="windowTitle" style={{ color: "black" }}>
            Inserisci lezione
          </div>

          {/* <TextInput readOnly={false} name={"Data"} value={this.props.date} /> */}
          <MyDatePicker
            name={"Data"}
            onChange={this.handleDateChange}
            selected={selectedDate}
            dateFormat="dd/MM/yyyy"
          />

          {/* Campo Orario: nascosto quando la giornata è divisa a metà */}
          {!this.state.divisaInMeta && (
            <TimeInput
              autoFocus
              readOnly={false}
              name={"Orario"}
              value={this.state.time}
              onChange={(val) => this.setState({ time: val })}
            />
          )}

          <InserimentoMultiploWidget ref={this.inserimentoMultiploWidget} />

          <TextNumberInput
            name={"Durata"}
            value={this.state.slots}
            minValue="1"
            maxValue="10"
            onChange={(val) =>
              this.setState({ slots: val, value: this.state.value })
            }
          />

          <Checkbox
            name="Pagamento Quota"
            value={this.state.pagamentoQuota}
            onChange={(val) => this.setState({ pagamentoQuota: val })}
          />

          <Checkbox
            name="Dividi giornata in due metà"
            value={this.state.divisaInMeta}
            onChange={(val) => {
              this.setState({ divisaInMeta: val });
              // Se attivata, nascondi i campi normali
              if (val) {
                this.setState({
                  selectedInsegnanti: [],
                  selectedMaterie: [],
                });
              } else {
                // Se disattivata, resetta le metà
                this.setState({
                  selectedInsegnantiMeta1: [],
                  selectedMaterieMeta1: [],
                  selectedInsegnantiMeta2: [],
                  selectedMaterieMeta2: [],
                });
              }
            }}
          />

          {/* SEZIONE PER LEZIONE NORMALE (senza divisione) */}
          {!this.state.divisaInMeta && (
            <>
              <Button
                onClick={() => this.addInsegnante()}
                style={{
                  marginTop: "10px",
                  backgroundColor: "#a00308",
                  color: "white",
                  display: "block",
                }}
              >
                Aggiungi Insegnante
              </Button>

              {this.state.selectedInsegnanti.map((insegnante, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "end",
                  }}
                >
                  <SelectInput
                    key={index}
                    ref={this.selectRef}
                    value={insegnante}
                    name={`Insegnante ${index + 1}`}
                    options={this.selectInsegnanti}
                    onChange={(option) =>
                      this.handleInsegnanteChange(option, index)
                    }
                  />
                  {index >= 0 && (
                    <Button
                      onClick={() => this.removeInsegnante(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  )}
                </div>
              ))}

              <Button
                onClick={() => this.addMateria()}
                style={{
                  marginTop: "10px",
                  backgroundColor: "#a00308",
                  color: "white",
                  display: "block",
                }}
              >
                Aggiungi Materia
              </Button>

              {this.state.selectedMaterie.map((materia, index) => (
                <div key={index} style={{ display: "flex", alignItems: "end" }}>
                  <SelectInput
                    value={materia}
                    name={`Materia ${index + 1}`}
                    options={this.selectMaterie}
                    onChange={(option) =>
                      this.handleMateriaChange(option, index)
                    }
                  />
                  <Button
                    onClick={() => this.removeMateria(index)}
                    style={{ marginBottom: "8px" }}
                  >
                    ❌
                  </Button>
                </div>
              ))}
            </>
          )}

          {/* SEZIONE PER LEZIONE DIVISA IN DUE METÀ */}
          {this.state.divisaInMeta && (
            <>
              {/* PRIMA METÀ */}
              <div
                style={{
                  border: "2px solid #4CAF50",
                  borderRadius: "8px",
                  padding: "15px",
                  marginTop: "15px",
                  backgroundColor: "#f0f8f0",
                }}
              >
                <h3 style={{ color: "#4CAF50", marginTop: 0 }}>
                  🌅 Prima metà
                </h3>

                <TimeInput
                  readOnly={false}
                  name={"Ora inizio"}
                  value={this.state.oraInizioMeta1}
                  onChange={(val) => this.setState({ oraInizioMeta1: val })}
                />

                <TimeInput
                  readOnly={false}
                  name={"Ora fine"}
                  value={this.state.oraFineMeta1}
                  onChange={(val) => this.setState({ oraFineMeta1: val })}
                />

                <Button
                  onClick={() => this.addInsegnanteMeta1()}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Insegnante
                </Button>

                {this.state.selectedInsegnantiMeta1.map((insegnante, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "end",
                    }}
                  >
                    <SelectInput
                      value={insegnante}
                      name={`Insegnante ${index + 1}`}
                      options={this.selectInsegnanti}
                      onChange={(option) =>
                        this.handleInsegnanteMeta1Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeInsegnanteMeta1(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}

                <Button
                  onClick={() => this.addMateriaMeta1()}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Materia
                </Button>

                {this.state.selectedMaterieMeta1.map((materia, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      value={materia}
                      name={`Materia ${index + 1}`}
                      options={this.selectMaterie}
                      onChange={(option) =>
                        this.handleMateriaMeta1Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeMateriaMeta1(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}

                <Button
                  onClick={() => this.addAulaMeta1()}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Aula
                </Button>

                {this.state.selectedAuleMeta1.map((aula, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      value={aula}
                      name={`Aula ${index + 1}`}
                      options={this.selectAule}
                      onChange={(option) =>
                        this.handleAulaMeta1Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeAulaMeta1(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}
              </div>

              {/* SECONDA METÀ */}
              <div
                style={{
                  border: "2px solid #FF9800",
                  borderRadius: "8px",
                  padding: "15px",
                  marginTop: "15px",
                  backgroundColor: "#fff8f0",
                }}
              >
                <h3 style={{ color: "#FF9800", marginTop: 0 }}>
                  🌆 Seconda metà
                </h3>

                <TimeInput
                  readOnly={false}
                  name={"Ora inizio"}
                  value={this.state.oraInizioMeta2}
                  onChange={(val) => this.setState({ oraInizioMeta2: val })}
                />

                <TimeInput
                  readOnly={false}
                  name={"Ora fine"}
                  value={this.state.oraFineMeta2}
                  onChange={(val) => this.setState({ oraFineMeta2: val })}
                />

                <Button
                  onClick={() => this.addInsegnanteMeta2()}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#FF9800",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Insegnante
                </Button>

                {this.state.selectedInsegnantiMeta2.map((insegnante, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "end",
                    }}
                  >
                    <SelectInput
                      value={insegnante}
                      name={`Insegnante ${index + 1}`}
                      options={this.selectInsegnanti}
                      onChange={(option) =>
                        this.handleInsegnanteMeta2Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeInsegnanteMeta2(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}

                <Button
                  onClick={() => this.addMateriaMeta2()}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#FF9800",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Materia
                </Button>

                {this.state.selectedMaterieMeta2.map((materia, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      value={materia}
                      name={`Materia ${index + 1}`}
                      options={this.selectMaterie}
                      onChange={(option) =>
                        this.handleMateriaMeta2Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeMateriaMeta2(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}

                <Button
                  onClick={() => this.addAulaMeta2()}
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#FF9800",
                    color: "white",
                    display: "block",
                  }}
                >
                  Aggiungi Aula
                </Button>

                {this.state.selectedAuleMeta2.map((aula, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <SelectInput
                      value={aula}
                      name={`Aula ${index + 1}`}
                      options={this.selectAule}
                      onChange={(option) =>
                        this.handleAulaMeta2Change(option, index)
                      }
                    />
                    <Button
                      onClick={() => this.removeAulaMeta2(index)}
                      style={{ marginBottom: "8px" }}
                    >
                      ❌
                    </Button>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* <SelectInput
						key={Math.random()}
						ref={this.selectRef}
						value={this.state.altriCorsi}
						name={"Altri Corsi"}
						options={this.selectCorsi}
						isMulti={true}
						onChange={option => {
							this.setState({
								altriCorsi: option,
							});
						}}
					/> */}

          {/* Aula generale - nascosta se la giornata è divisa */}
          {!this.state.divisaInMeta && (
            <SelectInput
              key={Math.random()}
              ref={this.selectRef}
              value={this.state.aula}
              name={
                this.state.pagamentoQuota
                  ? "Aula (opzionale per pagamento quota)"
                  : "Aula"
              }
              options={this.selectAule}
              onChange={(option) => this.setState({ aula: option })}
            />
          )}

          <br />

          <FixButton
            title={"Save"}
            callback={this.state.isLoading ? () => {} : this.lockedSaveLesson}
            isLoading={this.state.isLoading}
          />
        </div>
      </div>
    );
  }

  checkInvestor(investors, id) {
    investors.map((v) => {
      if (v.id == id) return true;
    });
    return false;
  }

  async saveLesson() {
    this.setState({ isLoading: true });

    try {
      if (this.state.slots < 0.5 || this.state.slots > 10) {
        return;
      }

      // Validazione: se divisa in metà, controlla che ci siano insegnanti/materie per almeno una metà
      // Tutti i campi (aula, insegnanti, materie) sono ora opzionali
      // sia per lezioni normali che per lezioni divise

      var id_materia =
        this.state.materia && this.state.materia.value
          ? this.state.materia.value
          : null;
      var id_aula = this.state.aula ? this.state.aula.value : null;

      // Se la lezione è divisa, prepara i dati delle sessioni
      let insegnantiIds, materieIds;

      if (this.state.divisaInMeta) {
        // Per lezioni divise, usiamo valori dummy per la lezione principale
        // I veri dati saranno nelle sessioni
        insegnantiIds = "";
        materieIds = "";
      } else {
        // Per lezioni normali, usa i dati come prima
        insegnantiIds = this.state.selectedInsegnanti
          .filter((insegnante) => insegnante)
          .map((insegnante) => insegnante.value)
          .join(",");

        materieIds = this.state.selectedMaterie
          .filter((materia) => materia)
          .map((materia) => materia.value)
          .join(",");
      }

      const cookies = new Cookies();
      const username = cookies.get("username", { path: "/" });
      const token = cookies.get("token", { path: "/" });
      const id_corso = cookies.get("currentCourse", { path: "/" });

      this.chiusura = await getChiusura(username, token);
      this.corso = await getCorso(username, token, id_corso);

      // Validazione: verifica che la data sia nel periodo del corso
      if (this.corso && this.corso.dateStart && this.corso.dateEnd) {
        const dataSelezionata = moment(this.state.date, "YYYY-MM-DD");
        const dataInizioCorso = moment(this.corso.dateStart, "YYYY-MM-DD");
        const dataFineCorso = moment(this.corso.dateEnd, "YYYY-MM-DD");

        if (
          !dataSelezionata.isBetween(
            dataInizioCorso,
            dataFineCorso,
            "day",
            "[]"
          )
        ) {
          alert(
            `La data inserita (${dataSelezionata.format(
              "DD/MM/YYYY"
            )}) deve essere nel periodo del corso:\n` +
              `${dataInizioCorso.format("DD/MM/YYYY")} - ${dataFineCorso.format(
                "DD/MM/YYYY"
              )}`
          );
          this.setState({ isLoading: false });
          return;
        }
      }

      this.corsoDateEnd = moment(this.corso.dateEnd, "yyyy-MM-DD");

      const date = this.state.date;
      const hour = this.state.time.split(":")[0];
      const minutes = this.state.time.split(":")[1];
      const durata = this.state.slots * 60;
      const pagamentoQuota = this.state.pagamentoQuota ? 1 : 0; // Convertiamo il booleano in 1/0 per il database
      const multiploValues = this.inserimentoMultiploWidget.current.getValues();

      var giorniDefiniti = false;
      multiploValues.giorniSettimana.forEach((g) => {
        if (g == true) giorniDefiniti = true;
      });

      console.log("Valori inserimento multiplo:", multiploValues);
      console.log("Giorni definiti:", giorniDefiniti);
      var altriCorsi = "";
      this.state.altriCorsi &&
        this.state.altriCorsi.forEach((i) => {
          altriCorsi += i.value + ";";
        });

      // Logica corretta:
      // 1 = solo quella settimana
      // 2 = quella settimana + 1 ripetizione (2 settimane totali)
      // 3 = quella settimana + 2 ripetizioni (3 settimane totali)
      const settimane =
        giorniDefiniti && multiploValues.ripetizioni > 0
          ? multiploValues.ripetizioni
          : 1;

      // Calcola il numero totale di lezioni in base ai giorni selezionati e alle settimane
      const giorniSelezionatiCount = multiploValues.giorniSettimana.filter(
        (g) => g === true
      ).length;
      const ripetizioni = giorniDefiniti
        ? settimane * giorniSelezionatiCount
        : 1;
      if (!giorniDefiniti || giorniSelezionatiCount === 0) {
        console.log(
          "Inserimento singolo - settimane:",
          settimane,
          "giorni definiti:",
          giorniDefiniti,
          "ripetizioni totali:",
          ripetizioni
        );
        var res = await AddLezione(
          username,
          token,
          date,
          hour,
          minutes,
          durata,
          id_corso,
          insegnantiIds,
          altriCorsi,
          materieIds,
          id_aula,
          pagamentoQuota
        );
        if (res.result == "KO") {
          this.count++;
          alert(res.description);
        } else {
          // Se la lezione è divisa, crea SEMPRE le due sessioni (anche se vuote)
          if (this.state.divisaInMeta && res.id) {
            const idLezione = res.id;

            try {
              // Crea sessione 1 (Prima metà) - SEMPRE
              const insegnantiMeta1Ids = this.state.selectedInsegnantiMeta1
                .filter((i) => i)
                .map((i) => i.value)
                .join(",");
              const materieMeta1Ids = this.state.selectedMaterieMeta1
                .filter((m) => m)
                .map((m) => m.value)
                .join(",");
              const auleMeta1Ids = this.state.selectedAuleMeta1
                .filter((a) => a)
                .map((a) => a.value)
                .join(",");

              const respSess1 = await addSessioneLezione(
                username,
                token,
                idLezione,
                1, // ordine = prima metà
                this.state.oraInizioMeta1,
                this.state.oraFineMeta1,
                insegnantiMeta1Ids,
                materieMeta1Ids,
                auleMeta1Ids
              );
              if (respSess1.result === "KO") {
                console.warn(
                  "Impossibile creare sessione 1 (API backend non disponibile)"
                );
              }

              // Crea sessione 2 (Seconda metà) - SEMPRE
              const insegnantiMeta2Ids = this.state.selectedInsegnantiMeta2
                .filter((i) => i)
                .map((i) => i.value)
                .join(",");
              const materieMeta2Ids = this.state.selectedMaterieMeta2
                .filter((m) => m)
                .map((m) => m.value)
                .join(",");
              const auleMeta2Ids = this.state.selectedAuleMeta2
                .filter((a) => a)
                .map((a) => a.value)
                .join(",");

              const respSess2 = await addSessioneLezione(
                username,
                token,
                idLezione,
                2, // ordine = seconda metà
                this.state.oraInizioMeta2,
                this.state.oraFineMeta2,
                insegnantiMeta2Ids,
                materieMeta2Ids,
                auleMeta2Ids
              );
              if (respSess2.result === "KO") {
                console.warn(
                  "Impossibile creare sessione 2 (API backend non disponibile)"
                );
              }
            } catch (error) {
              console.error(
                "Errore nella creazione delle sessioni (API backend probabilmente non implementata):",
                error
              );
              // Continua comunque, la lezione è stata salvata
            }
          }

          this.props.onDone();
        }
      } else {
        console.log(
          "Inserimento multiplo iniziato - settimane:",
          settimane,
          "giorni selezionati:",
          giorniSelezionatiCount,
          "ripetizioni totali:",
          ripetizioni
        );
        var momentDate = moment(date, "YYYY-MM-DD");
        var errorInsert = false;
        var lezioniInserite = 0;
        var lezioniPreviste = ripetizioni;
        var lezioniSaltateChiusura = 0;
        var lezioniSaltateFineCurso = 0;
        var lezioniSaltatePassate = 0; // Giorni già trascorsi
        var lezioniErroreAula = []; // Array per tracciare lezioni con aula occupata
        var lezioniAltriErrori = []; // Array per altri errori
        console.log(
          "Data iniziale:",
          date,
          "moment date:",
          momentDate.format("YYYY-MM-DD")
        );
        console.log(
          "Giorni selezionati array:",
          multiploValues.giorniSettimana
        );
        console.log(
          "Mappatura giorni: lun=0, mar=1, mer=2, gio=3, ven=4, sab=5, dom=6"
        );
        console.log(
          "Date in chiusura:",
          this.chiusura?.map((c) =>
            moment(c.day, "DD-MM-yyyy HH:mm:ss").format("YYYY-MM-DD")
          )
        );
        console.log(
          "Data fine corso:",
          this.corsoDateEnd
            ? this.corsoDateEnd.format("YYYY-MM-DD")
            : "non definita"
        );

        // Ciclo per ogni settimana
        for (let settimana = 0; settimana < settimane; settimana++) {
          console.log(`=== SETTIMANA ${settimana + 1} di ${settimane} ===`);

          // Per ogni settimana, cerca i giorni selezionati
          for (let giornoIdx = 0; giornoIdx < 7; giornoIdx++) {
            if (!multiploValues.giorniSettimana[giornoIdx]) {
              continue; // Salta giorni non selezionati
            }

            // Calcola la data per questo giorno della settimana
            var dataSettimanaInizio = moment(date, "YYYY-MM-DD").add(
              settimana,
              "weeks"
            );
            // Converti indice array (0=Lun, 1=Mar, ..., 6=Dom) in day() di moment (1=Lun, 2=Mar, ..., 0=Dom)
            var giornoDellaSettimana = (giornoIdx + 1) % 7;
            var dataLezione = dataSettimanaInizio
              .clone()
              .day(giornoDellaSettimana);

            // Se siamo nella prima settimana e la data è precedente alla data iniziale, salta
            if (
              settimana === 0 &&
              dataLezione.isBefore(moment(date, "YYYY-MM-DD"))
            ) {
              console.log("Data già trascorsa, saltata:", tempDate);
              lezioniSaltatePassate++;
              continue;
            }

            var tempDate = dataLezione.format("YYYY-MM-DD");
            var giornoNome = [
              "Lunedì",
              "Martedì",
              "Mercoledì",
              "Giovedì",
              "Venerdì",
              "Sabato",
              "Domenica",
            ][giornoIdx];

            console.log(
              `Processando giorno ${giornoIdx} (${
                ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"][giornoIdx]
              }) settimana ${settimana + 1}: ${tempDate}`
            );

            // Verifica data fine corso
            if (this.corsoDateEnd && dataLezione.isAfter(this.corsoDateEnd)) {
              console.log("Data oltre fine corso, saltata:", tempDate);
              lezioniSaltateFineCurso++;
              continue;
            }

            // Verifica chiusura
            var flagChiusura = false;
            this.chiusura.forEach((c) => {
              var chiusura = moment(c.day, "DD-MM-yyyy HH:mm:ss").format(
                "YYYY-MM-DD"
              );
              if (chiusura === tempDate) flagChiusura = true;
            });

            if (flagChiusura) {
              console.log("DATA IN CHIUSURA, saltata:", tempDate);
              lezioniSaltateChiusura++;
              continue;
            }

            console.log("INSERENDO LEZIONE per data:", tempDate);
            var altriCorsi = "";
            this.state.altriCorsi &&
              this.state.altriCorsi.forEach((i) => {
                altriCorsi += i.value + ";";
              });

            var res = await AddLezione(
              username,
              token,
              tempDate,
              hour,
              minutes,
              durata,
              id_corso,
              insegnantiIds,
              altriCorsi,
              materieIds,
              id_aula,
              pagamentoQuota
            );

            if (res.result == "KO") {
              console.log("ERRORE inserimento lezione:", res.description);

              // Distingui tra aula occupata e altri errori
              if (
                res.description &&
                res.description.toLowerCase().includes("occupata")
              ) {
                lezioniErroreAula.push({
                  data: tempDate,
                  giorno: giornoNome,
                  aula: this.state.selectedAula
                    ? this.state.selectedAula.label
                    : "N/A",
                  descrizione: res.description,
                });
              } else {
                lezioniAltriErrori.push({
                  data: tempDate,
                  giorno: giornoNome,
                  descrizione: res.description,
                });
              }

              errorInsert = true;
            } else {
              console.log("SUCCESSO lezione inserita per data:", tempDate);
              lezioniInserite++;

              // Se la lezione è divisa, crea SEMPRE le due sessioni (anche se vuote)
              if (this.state.divisaInMeta && res.id) {
                const idLezione = res.id;

                // Crea sessione 1 (Prima metà) - SEMPRE
                const insegnantiMeta1Ids = this.state.selectedInsegnantiMeta1
                  .filter((i) => i)
                  .map((i) => i.value)
                  .join(",");
                const materieMeta1Ids = this.state.selectedMaterieMeta1
                  .filter((m) => m)
                  .map((m) => m.value)
                  .join(",");
                const auleMeta1Ids = this.state.selectedAuleMeta1
                  .filter((a) => a)
                  .map((a) => a.value)
                  .join(",");

                await addSessioneLezione(
                  username,
                  token,
                  idLezione,
                  1,
                  this.state.oraInizioMeta1,
                  this.state.oraFineMeta1,
                  insegnantiMeta1Ids,
                  materieMeta1Ids,
                  auleMeta1Ids
                );

                // Crea sessione 2 (Seconda metà) - SEMPRE
                const insegnantiMeta2Ids = this.state.selectedInsegnantiMeta2
                  .filter((i) => i)
                  .map((i) => i.value)
                  .join(",");
                const materieMeta2Ids = this.state.selectedMaterieMeta2
                  .filter((m) => m)
                  .map((m) => m.value)
                  .join(",");
                const auleMeta2Ids = this.state.selectedAuleMeta2
                  .filter((a) => a)
                  .map((a) => a.value)
                  .join(",");

                await addSessioneLezione(
                  username,
                  token,
                  idLezione,
                  2,
                  this.state.oraInizioMeta2,
                  this.state.oraFineMeta2,
                  insegnantiMeta2Ids,
                  materieMeta2Ids,
                  auleMeta2Ids
                );
              }
            }
          }
        }

        // Calcola lezioni effettivamente saltate per motivi validi
        var lezioniValidamenteSaltate =
          lezioniSaltateChiusura +
          lezioniSaltateFineCurso +
          lezioniSaltatePassate;
        var lezioniAtteseEffettive =
          lezioniPreviste - lezioniValidamenteSaltate;

        console.log("RIEPILOGO INSERIMENTO:");
        console.log("- Lezioni previste inizialmente:", lezioniPreviste);
        console.log("- Lezioni saltate per chiusura:", lezioniSaltateChiusura);
        console.log(
          "- Lezioni saltate per fine corso:",
          lezioniSaltateFineCurso
        );
        console.log("- Lezioni saltate (date passate):", lezioniSaltatePassate);
        console.log("- Lezioni con errore aula:", lezioniErroreAula.length);
        console.log("- Lezioni con altri errori:", lezioniAltriErrori.length);
        console.log("- Lezioni attese effettive:", lezioniAtteseEffettive);
        console.log("- Lezioni inserite:", lezioniInserite);

        // Mostra messaggi separati: uno per le info, uno per gli errori

        // 1. Messaggio informativo (date passate, chiusure, fine corso)
        if (lezioniValidamenteSaltate > 0) {
          var messaggioInfo = "Informazioni inserimento:\n";

          if (lezioniSaltatePassate > 0) {
            messaggioInfo +=
              "\n• " +
              lezioniSaltatePassate +
              " lezione/i saltate (date già trascorse)";
          }
          if (lezioniSaltateChiusura > 0) {
            messaggioInfo +=
              "\n• " +
              lezioniSaltateChiusura +
              " lezione/i saltate (giorni di chiusura)";
          }
          if (lezioniSaltateFineCurso > 0) {
            messaggioInfo +=
              "\n• " +
              lezioniSaltateFineCurso +
              " lezione/i saltate (oltre la data di fine corso)";
          }

          messaggioInfo +=
            "\n\n✓ Lezioni inserite correttamente: " + lezioniInserite;

          alert(messaggioInfo);
        }

        // 2. Messaggio di errore (aule occupate e altri problemi)
        if (lezioniErroreAula.length > 0 || lezioniAltriErrori.length > 0) {
          var messaggioErrore =
            "Attenzione - Alcune lezioni NON sono state inserite:\n";

          if (lezioniErroreAula.length > 0) {
            messaggioErrore += "\n🚫 AULA OCCUPATA:";
            lezioniErroreAula.forEach((err) => {
              messaggioErrore +=
                "\n• " + err.giorno + " " + err.data + " - Aula: " + err.aula;
            });
          }

          if (lezioniAltriErrori.length > 0) {
            messaggioErrore += "\n\n⚠️ ALTRI ERRORI:";
            lezioniAltriErrori.forEach((err) => {
              messaggioErrore +=
                "\n• " + err.giorno + " " + err.data + ": " + err.descrizione;
            });
          }

          messaggioErrore +=
            "\n\n✓ Lezioni inserite correttamente: " + lezioniInserite;

          alert(messaggioErrore);
        }

        // 3. Messaggio di successo completo (solo se tutto ok e nessun salto)
        if (
          lezioniInserite === lezioniPreviste &&
          lezioniValidamenteSaltate === 0 &&
          lezioniErroreAula.length === 0 &&
          lezioniAltriErrori.length === 0
        ) {
          alert(
            "✓ Tutte le " +
              lezioniInserite +
              " lezioni sono state inserite correttamente!"
          );
        }

        this.props.onDone();
      }
    } catch (error) {
      console.error("Errore durante il salvataggio della lezione:", error);
      alert("Si è verificato un errore durante il salvataggio della lezione");
    } finally {
      if (this._isMounted) {
        this.setState({ isLoading: false });
      }
    }
  }

  handleChangeMultiple = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({ value: value });
  };
}

const closeIcon = {
  position: "absolute",
  cursor: "pointer",
  right: 0,
  top: 0,
  padding: 10,
};

const mainClass = {
  position: "fixed",
  left: "35%",
  top: "10%",
  background: "#ffffff",
  border: "1px solid black",
  padding: "20px",
  overflow: "scroll",
  height: "600px",
  zIndex: 999,
};
